export default __webpack_public_path__ + "static/media/guide23.282b7caf.png";